import React from "react";
import "../styles/about.css";
import bgImage from "../assets/ss3.png"; // replace with your image

function About() {
    return (
        <div
            className="about-bg"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="about-overlay">
                <div className="about-wrapper">

                    {/* ABOUT SECTION */}
                    <section className="about-block">
                        <h1>About Us</h1>
                        <p>
                            At <strong>TPA Bricks</strong>, we specialize in manufacturing
                            high-quality, durable, and eco-friendly red bricks designed for
                            residential, commercial, and industrial construction. Our
                            production process blends traditional kiln craftsmanship with
                            advanced technology, ensuring every brick offers lasting strength,
                            consistency, and reliability.
                        </p>
                        <p>
                            With a commitment to excellence, our materials support builders,
                            contractors, and homeowners in creating structures that stand the
                            test of time.
                        </p>
                    </section>
                    {/* MISSION */}

                    <section className="about-block">
                        <h1>Our Mission</h1>
                        <p>
                            Our mission is to empower builders and homeowners by providing
                            materials that contribute to stronger, safer, and more sustainable
                            structures. We aim to be a leading manufacturer that supports a
                            greener future through eco-responsible brick production and
                            innovation.
                        </p>
                        <p>
                            Every brick we craft reflects our values — strength, trust, and
                            long-lasting quality.
                        </p>
                    </section>

                    {/* WHY CHOOSE US */}
                    <section className="about-block">
                        <h1>Why Choose Us</h1>
                        <p>
                            TPA Bricks stands apart through its dedication to quality,
                            precision, and sustainable production. We ensure that every brick
                            meets strict standards, offering superior durability and elegant
                            finish for all types of construction work.
                        </p>
                        <p>
                            Our focus on timely delivery, fair pricing, and dependable service
                            makes us a trusted choice for more than 100+ projects across the region.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default About;

